<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            :clearable="clearable"
            :multiple="multiple"
            :dense="dense"
            :disabled="disabled"
            :outlined="outlined"
            @change="$emit('change', $event)"
            @input="$emit('input', $event)"
            :hideDetails="hideDetails"
            :class="classe"
            :selectAll="selectAll"
            :classe="classe"
            :background-color="backgroundColor"
            :color="color"
        />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectIntegrationShift',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        selectAll: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        maxShift: {
            type: Number,
            default: 3
        },
        dense: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        hideDetails: {
            type: [Boolean,String],
            default: false
        },
        classe: {

        },
        shiftId: {

        },
        backgroundColor: {},
        color: {},
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        shiftId(val){
            this.getItems();
        },
    },
    methods: {
        ...mapActions('integration', ['ActionIndexIntegrationShifts']),
        
        async getItems() {

            this.loading = true;
            let payload = {
                find_columns: {
                    active: 1
                }
            }

            if(this.shiftId){
                payload.find_columns.shift_id = this.shiftId;
            }

            await this.ActionIndexIntegrationShifts(payload)
                    .then((res) => {
                        
                        this.items = res.data;
                        this.selected = this.model;

                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },
    },
    
}
</script>